import apiClient from './client';

export const employeesAPI = {
  getAll: async () => {
    // Trailing slash важен для FastAPI
    const response = await apiClient.get('/employees/');
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/employees/${id}`);
    return response.data;
  },

  create: async (employeeData) => {
    // Trailing slash важен для FastAPI
    const response = await apiClient.post('/employees/', employeeData);
    return response.data;
  },

  update: async (id, updateData) => {
    const response = await apiClient.patch(`/employees/${id}`, updateData);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/employees/${id}`);
    return response.data;
  },
};
